import { render } from "./SectionCookies.vue?vue&type=template&id=407fc699&scoped=true"
import script from "./SectionCookies.vue?vue&type=script&lang=js"
export * from "./SectionCookies.vue?vue&type=script&lang=js"

import "./SectionCookies.vue?vue&type=style&index=0&id=407fc699&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407fc699"]])

export default __exports__